import tippy from 'tippy.js';

export default {
  props: {
    tooltip: { type: String, default: null },
    tooltipArrow: { type: Boolean, default: true },
    tooltipPlacement: { type: String, default: 'bottom' },
    tooltipDisabled: { type: Boolean, default: false },
    tooltipFollowCursor: { type: [Boolean, String], default: false },
  },
  data() {
    return {
      tippyRef: null,
      tippyInstance: null,
      destroyed: false,
    };
  },
  watch: {
    tooltip() {
      this.destroyTooltip();
      this.setupTooltip();
    },
    tooltipArrow() {
      this.destroyTooltip();
      this.setupTooltip();
    },
    tooltipPlacement() {
      this.destroyTooltip();
      this.setupTooltip();
    },
    tooltipFollowCursor() {
      this.destroyTooltip();
      this.setupTooltip();
    },
    tooltipDisabled(isDisabled) {
      if (!this.tippyInstance) return;
      if (isDisabled) {
        this.tippyInstance.disable();
      } else {
        this.tippyInstance.enable();
      }
    },
  },
  mounted() {
    this.setupTooltip();
  },
  beforeDestroy() {
    this.destroyTooltip();
  },
  methods: {
    setupTooltip() {
      if (!this.tooltip) {
        return;
      }

      if (this.tooltipArrow !== undefined) {
        this.$el.setAttribute('data-tippy-arrow', this.tooltipArrow);
      }

      if (this.tooltipPlacement !== undefined) {
        this.$el.setAttribute('data-tippy-placement', this.tooltipPlacement);
      }

      if (this.tooltipFollowCursor) {
        this.$el.setAttribute('data-tippy-followCursor', this.tooltipFollowCursor);
      }

      this.tippyInstance = tippy(this.$el, {
        content: this.tooltip,
        allowHTML: true,
      });
      this.destroyed = false;

      if (this.tooltipDisabled) {
        this.tippyInstance.disable();
      }
    },
    destroyTooltip() {
      if (this.tippyInstance && !this.destroyed) {
        this.destroyed = true;
        this.tippyInstance.destroy();
      }
    },
    showTooltip() {
      if (this.tippyInstance) {
        this.tippyInstance.show();
      }
    },
    disableTooltip() {
      if (this.tippyInstance) {
        this.tippyInstance.disable();
      }
    },
    enableTooltip() {
      if (this.tippyInstance) {
        this.tippyInstance.enable();
      }
    },
  },
};
